/* eslint-disable */
import React, { useState, useEffect }  from 'react'
import { DatePicker } from 'antd'
import PropTypes from 'prop-types'
import { isEqual, omit } from 'lodash'
import dayjs from 'dayjs'
import { handleControl } from './control'
import { renderLabelString } from '@/utils/renderUtils'

const { RangePicker } = DatePicker

const I2RangePickerC = (props) => {

  const {
    propsClassName, propsClassSpan, style,// 样式 className
    modalProps, mode, label, ending, picker,// 组件 功能参数
    query, value, searchKey, dateStrValue, dateOfType,// 组件 数据源
    path, clearKey, requestType, killPending, // 请求相关控制数据
    action, actionChange, resAction, headerchange // 请求方法
  } = props
  const handleValue = [
    query[searchKey[0]] ? dayjs(query[searchKey[0]]): undefined,
    query[searchKey[1]] ? dayjs(query[searchKey[1]]): undefined
  ]
  const [ useValue, setUseValue ] = useState(handleValue)

  useEffect(() => {
    setUseValue(handleValue)
  }, [query.refQ, query[searchKey[0]]])

  const handleChange = (e, eStr) => {
    setUseValue(e)
    let formatValue = {}
    switch (true) {
      case (!e): {
        formatValue = {
          [searchKey[0]]: undefined,
          [searchKey[1]]: undefined
        }
        break
      }
      // dateStrValue === true, 提交参数 为 字符串 根据 picker 类型
      case (dateStrValue): {
        // console.log('dateStrValue', eStr)
        formatValue = {
          [searchKey[0]]: eStr[0],
          [searchKey[1]]: eStr[1]
        }
        break
      }
      // dateOfType === true, 提交参数为，去除时分秒，根据picker参数
      case (dateOfType): {
        // console.log('dateOfType')
        formatValue = {
          [searchKey[0]]: +dayjs(e[0]).startOf(picker || 'day'),
          [searchKey[1]]: +dayjs(e[1]).endOf(picker || 'day')
        }
        break
      }
      // 默认 转换 时间戳
      default: {
        formatValue = {
          [searchKey[0]]: +dayjs(e[0]),
          [searchKey[1]]: +dayjs(e[1])
        }
        break
      }
    }
    // ----- 提交组件 -----------
    console.log('formatValue', formatValue)
    handleControl(
      props,
      formatValue
    )
  }
  return (
    <div className={propsClassName}>
      <span className={propsClassSpan} style={{ marginRight: '-2px' }}>{renderLabelString(label)}</span>
      <span style={style}>
        <RangePicker
          // picker = 'week'
          // picker = 'month'
          // picker = 'quarter'
          // picker = 'year'

          // -- modalProps
          allowClear={true}
          style={{ width: 240 }}
          {...modalProps}
          // ---
          defaultValue={useValue}
          value={useValue}
          onChange={handleChange}
        />
      </span>
    </div>
  )
}
export default I2RangePickerC

I2RangePickerC.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  modalProps: {},
  picker: undefined,
  query: {},
  dateStrValue: false,
  dateOfType: true,
  searchKey: ['start_date', 'end_date'],
  ending: false,
  killPending: false
}